import SecondaryMenuItem from "./SecondaryMenuItem";

export default SecondaryMenuItem;
